import '../globals/Modal.css';

import { IonIcon, IonModal } from '@ionic/react';
import React from 'react';
import { CloseButton } from '../globals/CloseButton';
import { FilterMenu } from './FilterMenu';
import { arrowBackOutline } from 'ionicons/icons';
import { FilterSubMenu } from './FilterSubMenu';
import { FilterProps } from './Filter';

export const FilterModal: React.FC<FilterProps> = (props) => {
  const currentCategoryDataSelected = props.categories.find(
    (cat) => cat.id === props.selectedParentTagId
  );

  return (
    <>
      <IonModal
        isOpen={props.showModal}
        swipeToClose={true}
        animated={true}
        backdropDismiss={true}
        cssClass={`absolute top-0 right-0 !left-auto !bottom-auto h-full w-full md:w-[calc(100%-16rem)] !m-0 ion-filter ${props.className}`}
        onDidDismiss={() => {
          props.openModal(false);
          props.setSelectedParentTag(null);
        }}
      >
        <div className="relative pt-12 pb-8 bg-white h-full w-full overflow-hidden md:absolute md:right-0 md:w-96">
          <div className={`block modal-cross z-50 absolute top-12 left-9`}>
            {props.selectedParentTagId !== null ? (
              <button
                className="flex justify-center items-center w-6 h-6 rounded-full bg-primary "
                onClick={() => props.setSelectedParentTag(null)}
              >
                <IonIcon
                  className="text-white text-l leading-none"
                  icon={arrowBackOutline}
                />
              </button>
            ) : (
              <CloseButton
                to={props.backUrl}
                onClick={() => props.openModal(false)}
              />
            )}
          </div>
          <div className="h-full">
            {currentCategoryDataSelected === undefined ? (
              <FilterMenu
                categories={props.categories}
                selectParentTag={props.selectParentTag}
                selectedSubTags={props.selectedSubTags}
                onResetFilter={props.onResetFilter}
              />
            ) : (
              <FilterSubMenu
                multipleSelect={props.multipleSelect}
                currentCategoryDataSelected={currentCategoryDataSelected}
                childrenTags={props.childrenTags}
                selectedParentTagId={props.selectedParentTagId}
                isSubTagSelected={props.isSubTagSelected}
                selectSubTag={props.selectSubTag}
                setAllSelected={props.setAllSelected}
                selectedSubTags={props.selectedSubTags}
              />
            )}
          </div>
        </div>
      </IonModal>
    </>
  );
};
